import { Sparkles, ArrowRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useTranslation } from '@/hooks/useTranslation'

interface ProFeatureGateProps {
	onUpgradeClick?: () => void
	onDismiss?: () => void
}

export function ProFeatureGate({ onUpgradeClick, onDismiss }: ProFeatureGateProps) {
	const { t } = useTranslation()
	return (
		<div
			className="p-4 rounded-lg border bg-gradient-to-br from-amber-50 to-orange-50 dark:from-amber-950/30 dark:to-orange-950/30 border-amber-200 dark:border-amber-800"
			role="region"
			aria-label={t('proFeatureGate.upgradeToProPromotion')}
		>
			<div className="flex gap-3">
				<div className="shrink-0 mt-0.5">
					<div className="h-8 w-8 rounded-lg bg-amber-100 dark:bg-amber-900/40 flex items-center justify-center">
						<Sparkles className="h-4 w-4 text-amber-600 dark:text-amber-400" aria-hidden="true" />
					</div>
				</div>

				<div className="flex-1 space-y-2">
					<h4 className="text-sm font-semibold text-amber-900 dark:text-amber-100">
						{t('proFeatureGate.unlockCompleteVisitorContext')}
					</h4>
					<p className="text-xs text-amber-800 dark:text-amber-200 leading-relaxed">
						{t('proFeatureGate.seeTimezoneLanguageLocation')}
					</p>

					<div className="flex items-center gap-2 pt-1">
						<Button
							size="sm"
							className="bg-amber-600 hover:bg-amber-700 text-white h-8 text-xs"
							onClick={onUpgradeClick}
						>
							{t('proFeatureGate.upgradeToPro')}
							<ArrowRight className="h-3 w-3 ml-1" aria-hidden="true" />
						</Button>
						{onDismiss && (
							<Button
								size="sm"
								variant="ghost"
								className="h-8 text-xs text-amber-700 hover:text-amber-900 dark:text-amber-300 dark:hover:text-amber-100"
								onClick={onDismiss}
							>
								{t('proFeatureGate.notNow')}
							</Button>
						)}
					</div>
				</div>
			</div>
		</div>
	)
}
